module.exports = __webpack_public_path__ + "img/requisitos-title-mobile.8e548c2f.svg";